import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiDownloadCloud, FiStar, FiTag } from 'react-icons/fi';

const Hero = () => {
  const checkoutUrl = "https://encouragingbv.gumroad.com/l/biblebookmark";

  return (
    <section className="pt-32 pb-16 md:pt-40 md:pb-24 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div className="space-y-8">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-100/50 text-amber-800 text-sm font-medium border border-amber-200">
            <SafeIcon icon={FiStar} className="fill-amber-500 text-amber-500" />
            <span>Premium Digital Scripture Resource</span>
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight text-stone-900">
            Your Spiritual Compass,<br />
            <span className="text-amber-700">Right When You Need It.</span>
          </h1>
          
          <p className="text-lg text-stone-600 leading-relaxed max-w-xl">
            This exquisite <strong>Bible Emergency Numbers Bookmark</strong> bundle is more than just a page holder. Turn to scripture for comfort and guidance with just a glance.
          </p>

          <div className="bg-white p-6 rounded-2xl border border-amber-100 shadow-sm inline-block">
            <div className="flex items-center gap-4 mb-2">
              <span className="text-3xl font-bold text-stone-900">$4.99</span>
              <span className="text-lg text-stone-400 line-through decoration-amber-500/50 decoration-2">$45.00</span>
              <span className="bg-green-100 text-green-700 text-xs font-bold px-2 py-1 rounded uppercase tracking-wider">Save 89%</span>
            </div>
            <p className="text-stone-500 text-sm flex items-center gap-2">
              <SafeIcon icon={FiTag} className="text-amber-500" />
              Includes 8 Bonus Designs & Lifetime Access
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 pt-2">
            <a 
              href={checkoutUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-amber-600 hover:bg-amber-700 text-white px-8 py-4 rounded-xl font-bold text-lg transition-all shadow-lg shadow-amber-600/20 hover:shadow-xl hover:-translate-y-0.5 flex items-center justify-center gap-2"
            >
              <SafeIcon icon={FiDownloadCloud} className="text-xl" />
              Download & Print Instantly
            </a>
            <div className="flex flex-col justify-center">
              <p className="text-sm text-stone-900 font-bold uppercase tracking-tight">Digital Bundle</p>
              <p className="text-xs text-stone-500">Instant Email Delivery</p>
            </div>
          </div>
        </div>

        <div className="relative">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl bg-white p-2 transform rotate-1 hover:rotate-0 transition-transform duration-500 group">
            <div className="absolute inset-0 bg-gradient-to-tr from-stone-100 to-transparent opacity-0 group-hover:opacity-50 transition-opacity"></div>
            <img 
              src="https://media-manager-c.questera.ai/greta-media/bf058984a4ffdbb1bcf737e98ba89b4a0e9a3794368100afc61d724fc2136ffb549bddff932effd18582b107d1ceb382/images/aW1hZ2UvcG5n/d28a6a7d26795d4ae59c3cc82c44cb9a.png" 
              alt="Bible Emergency Numbers Bookmark in Bible" 
              className="w-full h-auto rounded-xl relative z-10"
            />
            <div className="absolute bottom-6 right-6 z-20 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-lg shadow-lg border border-stone-200 text-xs font-bold text-stone-800 uppercase tracking-widest">
              Instant Access
            </div>
          </div>
          <div className="absolute -top-6 -right-6 w-24 h-24 bg-amber-200 rounded-full blur-2xl opacity-60 -z-10"></div>
          <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-stone-300 rounded-full blur-3xl opacity-50 -z-10"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;